import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import "./FoodDatabase.scss";
import { togglePreloader, getFoodDetails, resetField } from "../../../store/actions";
import PaginatedTable from "../../../sharedComponents/tableWithPagination";
import { foodTypeList, servingsList } from "../../../constants/recipeConstants";

const FoodDetails = ({ foodDetails, match, getFoodDetails, history, isAdmin, foodDatabaselevels, resetField }) => {
	const foodId = (match && match.params && match.params.id) || null;

	useEffect(() => {
		getFoodDetails(foodId);
	}, [foodId, getFoodDetails]);

	const { name, source, long_desc, nut_data } = foodDetails;

	let [foodDetailsColumns] = useState([]);
	let [foodDetailsData] = useState([]);

	if (nut_data) {
		const columnHeader = nut_data[0];
		foodDetailsColumns = Object.keys(columnHeader).map((key) => {
			return {
				Header: columnHeader[key],
				accessor: key,
				sortable: false
			};
		});
		foodDetailsData = nut_data.slice(1);
	}

	const renderEditFoodItem = () => {
		history.push(`/nutrition/food-database/${foodId}/edit`);
	};

	const handleBackNavigation = () => {
		resetField("FoodDatabase.foodDatabaseBackData", foodDatabaselevels);
		resetField("FoodDatabase.foodDatabaselevels", null);
		history.push(`/nutrition/food-database`);
	};

	return (
		<section className="page page-food-details">
			<div className="container">
				<div className="d-flex justify-content-between align-items-center mb-2">
					<h3>
						<button
							className="btn btn-primary-dark btn-ghost mr-3"
							onClick={() => {
								handleBackNavigation();
							}}>
							<i className="icon icon-angle-left"></i>
						</button>
						{name ? name : long_desc}
					</h3>
					{isAdmin ? (
						<button className="btn btn-primary" onClick={renderEditFoodItem}>
							Edit <i className="ml-2 icon icon-add-edit" />
						</button>
					) : null}
				</div>
				<div className="block block-primary p-4">
					{nut_data && foodDetailsColumns && foodDetailsData ? (
						<React.Fragment>
							<PaginatedTable data={foodDetailsData} columns={foodDetailsColumns} pageSize={1000} />
							<p className="mt-4 font-weight-bold">
								Protein Calorie Type :
								{foodDetails && foodDetails.protein_calorie_type
									? foodTypeList.filter((item) => item.id === foodDetails.protein_calorie_type)[0].name
									: "N/A"}
							</p>
							<p className="font-weight-bold">
								Servings Type :
								{foodDetails && foodDetails.servings_type
									? servingsList.filter((item) => item.id === foodDetails.servings_type)[0].name
									: "N/A"}
							</p>
							<p> Nutritional data source: {source ? source : ""} </p>
							<p> Original long name: {long_desc ? long_desc : ""} </p>
						</React.Fragment>
					) : (
						[]
					)}
				</div>
			</div>
		</section>
	);
};

const mapStateToProps = (state) => {
	const { FoodDatabase, UI, Auth } = state;
	return {
		foodDetails: get(FoodDatabase, "getFoodDetailsResult", {}),
		atBottom: UI.atBottom,
		isAdmin: Auth.isAdmin,
		foodDatabaselevels: get(state, "FoodDatabase.foodDatabaselevels", [])
	};
};

const mapDispatchToProps = {
	togglePreloader,
	getFoodDetails,
	resetField
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(FoodDetails);
